import { instance } from "api/apiBase";
import { GetTemplatesResponse } from "api/landlord/templates";
import { ChangeTemplateResponse } from "./types";

export const getVerificationTemplates =
  async (): Promise<GetTemplatesResponse> => {
    return (await instance.get("/portal/v1/verification_templates")).data;
  };

export const changeApplicationTemplate = async (
  applicationId: string,
  verificationTemplateId: string
): Promise<ChangeTemplateResponse> => {
  return (
    await instance.patch(`/portal/v1/applications/${applicationId}/template`, {
      verification_template_id: verificationTemplateId
    })
  ).data;
};
